

import { GetThreadsBySite } from '@src/services/api-client'
import { useAuth } from '@src/modules/Auth/shared/state'
import { useEffect, useState } from 'react'


export function useUnreadMessagesCount() {
  const { currentSite } = useAuth()
  const [count, setCount] = useState(0)

  useEffect(() => {
    let cancelled = false
    if (!currentSite) {
      return undefined
    }
    const fetchCount = async () => {
      try {
        const res = await GetThreadsBySite({
          siteId: currentSite.id,
          offset: 0,
          limit: 1000
        })
        if (!cancelled) {
          setCount(res.data?.threads?.filter(thread => thread.unreadByAdmin).length || 0)
        }
      } catch (e) {
        if (!cancelled) setCount(0)
      }
    }
    fetchCount()
    const i = setInterval(fetchCount, 60000)
    return () => {
      cancelled = true
      clearInterval(i)
    }
  }, [currentSite])

  return count
}
